import type { QueryClient } from '@tanstack/react-query';
import type { Uppy } from '@uppy/core';
import { createContainer, token } from 'ditox';
import type I18n from 'i18next';
import type { SetupWorkerApi } from 'msw/browser';
import type { SetupServerApi } from 'msw/node';
import type { RespondedType } from '@/models/response';
import type { UppyFileMeta } from '@/models/uploadable';
import type CodeScanner from '@/services/code-scanner';
import type CommManager from '@/services/comm-manager';
import type { DynamicEndpointManager } from '@/services/dynamic-endpoint-manager';
import type FirebaseManager from '@/services/firebase-manager';
import type IntercomManager from '@/services/intercom-manager';
import type MessageManager from '@/services/message-manager';
import type QuillManager from '@/services/quill';
import type ServiceWorkerManager from '@/services/service-worker';
import type StorageManager from '@/services/storage-manager';
import type Transcoder from '@/services/transcoder';
import type WebSocketManager from '@/services/web-socket-manager';

export const container = createContainer();

export const ACTIVE_USER_TOKEN = token<number>('active-user');
export const I18N_TOKEN = token<typeof I18n>('i18next');
export const SUPPORTED_LNGS_TOKEN = token<{ value: string; label: string }[]>('i18next-supportedLngs');
export const QUERY_CLIENT_TOKEN = token<QueryClient>('query-client');
export const DYNAMIC_ENDPOINT_MANAGER_TOKEN = token<DynamicEndpointManager>('dynamic-endpoint-manager');
export const WEB_SOCKET_MANAGER_TOKEN = token<WebSocketManager>('web-socket-manager');
export const TRANSCODER_TOKEN = token<Transcoder>('transcoder');
export const COMM_MANAGER_TOKEN = token<CommManager>('comm-manager');
export const INTERCOM_MANAGER_TOKEN = token<IntercomManager>('intercom-manager');
export const FIREBASE_MANAGER_TOKEN = token<FirebaseManager>('firebase-manager');
export const MESSAGE_MANAGER_TOKEN = token<MessageManager>('message-manager');
export const STORAGE_MANAGER_TOKEN = token<StorageManager>('storage-manager');
export const SERVICE_WORKER_MANAGER_TOKEN = token<ServiceWorkerManager>('service-worker-manager');
export const CODE_SCANNER_TOKEN = token<CodeScanner>('code-scanner');
export const QUILL_MANAGER_TOKEN = token<QuillManager>('quill-manager');
export const UPPY_TOKEN = token<Uppy<UppyFileMeta, RespondedType>>('uppy');

// TEST MODULES
export const MSW_SERVER_TOKEN = token<SetupServerApi>('msw-server');
export const MSW_WORKER_TOKEN = token<SetupWorkerApi>('msw-worker');
